export default {
     ROOT_URL: "http://45.55.12.226:8000",
    //ROOT_URL:"http://localhost:8000",
    // ROOT_URL:"http://backend.yourctrip.com/",
    BUCKET_URL:"https://s3-us-west-1.amazonaws.com/utrip-bucket/",

}



// WEBPACK FOOTER //
// ./src/config/config.js